module.exports = "<div id=\"print-container\">\n\t<router-outlet></router-outlet>\n</div>"